function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #FF8618;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0.5;\r\n        isolation: isolate;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ovais-pagina-vagas"
}, /*#__PURE__*/React.createElement("path", {
  id: "oval-laranja-rotacao",
  className: "cls-1 rotate-center-right",
  d: "M1119.64,121.79a259.43,259.43,0,0,0-43-7.12l.17,0S833.68,86,595,234.81l.16,0c-67.42,38.19-120.66,105-141.9,189s-6.18,168,34.88,233.72c138.8,244,365.32,335,366.65,335.52a257.65,257.65,0,0,0,41,14.18c116.48,29.56,235.7-25.46,299.7-127.88,0,0,108.12-160.75,126.58-458.36h0C1333.09,282.84,1250,154.89,1119.64,121.79Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "oval-laranja",
  className: "cls-2",
  d: "M349.18,1067.16a303,303,0,0,0,50.74-5l-.18.11S683.26,1021.05,908,780.8l-.18.1c64.64-63.51,104.58-155,103.14-256.27S967,333.11,900.73,271.37C669.91,37.92,386.33,3.81,384.66,3.61A303,303,0,0,0,334,0C193.35,1.91,75.27,100.1,34,235.07c0,0-73.5,214.18-4.21,555.68h0C59.13,950,191.77,1069.27,349.18,1067.16Z"
})));

function SvgOvalVagas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1323.05 1067.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalVagas);
export default __webpack_public_path__ + "static/media/oval-vagas.ec188879.svg";
export { ForwardRef as ReactComponent };